"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _Text = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Text"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _A11yText = _interopRequireDefault(require("../../A11yText"));
var _renderTypography = _interopRequireDefault(require("./renderTypography"));
var _renderFootnoteLinks = _interopRequireDefault(require("./renderFootnoteLinks"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const selectStrikeThroughStyles = _ref => {
  let {
    strikeThroughColor
  } = _ref;
  return {
    textDecorationColor: strikeThroughColor
  };
};
const selectFootnoteLinksStyles = _ref2 => {
  let {
    bottomLinksMarginLeft
  } = _ref2;
  return {
    marginLeft: bottomLinksMarginLeft
  };
};
const renderCurrencySymbol = (currencySymbol, currencySymbolTypographyTokens, ratePosition, fontColor) => (0, _renderTypography.default)(`${currencySymbol}`, currencySymbolTypographyTokens, ratePosition, fontColor);
const renderAmount = (amount, amountTypographyTokens, strikeThrough, a11yText, fontColor, themeTokens) => {
  const amountText = (0, _renderTypography.default)(amount, amountTypographyTokens, undefined, fontColor); // undefined is ratePosition
  if (strikeThrough) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_A11yText.default, {
        text: a11yText
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        style: [staticStyles.strikeThroughContainer, selectStrikeThroughStyles(themeTokens)],
        children: amountText
      })]
    });
  }
  return amountText;
};
const renderPrice = (price, rateText, ratePosition, signDirection, currencySymbol, currencySymbolTypographyTokens, amountTypographyTokens, centsTypographyTokens, rateTypographyTokens, fontColor, strikeThrough, a11yText, bottomText, bottomLinksMarginLeft, footnoteLinks, onClickFootnote, themeTokens) => {
  const priceString = price;
  const lastDotPosition = priceString.lastIndexOf('.');
  const lastCommaPosition = priceString.lastIndexOf(',');
  const [separator, separatorPosition] = lastDotPosition > lastCommaPosition ? ['.', lastDotPosition] : [',', lastCommaPosition];

  // If the separator is at the fourth character from the end of the string or more, it's most probably
  // a part of the amount, and the cents are not included in the price string
  const EXCLUDE_CENTS = 3;
  const hasCents = separatorPosition !== -1 && separatorPosition >= priceString.length - EXCLUDE_CENTS;
  const amount = hasCents ? priceString.substring(0, separatorPosition) : priceString;
  const cents = hasCents ? priceString.substring(separatorPosition + 1) : null;
  const footnoteLinkPositionStyles = rateText ? staticStyles.footnoteLinksWithoutBottomText : staticStyles.footnoteLinksWithoutBottomTextAndRateText;
  const MAX_FOOTNOTE_LINKS_ALLOWED = 3;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
      style: ratePosition === 'bottom' ? staticStyles.priceContainerColumn : staticStyles.priceContainerRow,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
        style: staticStyles.priceContainer,
        children: [signDirection === 'left' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          children: renderCurrencySymbol(currencySymbol, currencySymbolTypographyTokens, ratePosition, fontColor)
        }) : null, renderAmount(amount, amountTypographyTokens, strikeThrough, a11yText, fontColor, themeTokens), cents ? (0, _renderTypography.default)(`${separator}${cents}`, centsTypographyTokens, undefined, fontColor) : null, signDirection === 'right' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          style: staticStyles.currencySymbol,
          children: renderCurrencySymbol(currencySymbol, currencySymbolTypographyTokens, ratePosition, fontColor)
        }) : null]
      }), rateText ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        style: ratePosition === 'bottom' ? staticStyles.rateTextVerticalPosition : [staticStyles.rateTextPosition, staticStyles.rateTextVerticalPosition],
        children: (0, _renderTypography.default)(rateText, rateTypographyTokens, ratePosition, fontColor)
      }) : null, !bottomText && footnoteLinks?.length <= MAX_FOOTNOTE_LINKS_ALLOWED ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        style: [footnoteLinkPositionStyles, selectFootnoteLinksStyles({
          bottomLinksMarginLeft
        })],
        children: (0, _renderFootnoteLinks.default)(footnoteLinks, themeTokens, onClickFootnote)
      }) : null]
    }), !bottomText && footnoteLinks?.length > MAX_FOOTNOTE_LINKS_ALLOWED ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
      style: staticStyles.verticalFootnoteLinkContainer,
      children: (0, _renderFootnoteLinks.default)(footnoteLinks, themeTokens, onClickFootnote)
    }) : null]
  });
};
var _default = exports.default = renderPrice;
const staticStyles = _StyleSheet.default.create({
  priceContainerRow: {
    flexDirection: 'row'
  },
  priceContainerColumn: {
    flexDirection: 'column'
  },
  priceContainer: {
    flexDirection: 'row',
    alignSelf: 'flex-start',
    marginTop: 4
  },
  currencySymbol: {
    paddingLeft: 4
  },
  verticalFootnoteLinkContainer: {
    ..._Platform.default.select({
      ios: {
        top: 10
      },
      android: {
        top: -2
      }
    })
  },
  footnoteLinksWithoutBottomText: {
    ..._Platform.default.select({
      ios: {
        alignSelf: 'flex-end',
        top: -10
      },
      android: {
        alignSelf: 'center',
        top: -14
      }
    })
  },
  footnoteLinksWithoutBottomTextAndRateText: {
    ..._Platform.default.select({
      ios: {
        alignSelf: 'center'
      },
      android: {
        alignSelf: 'flex-start'
      }
    })
  },
  strikeThroughContainer: {
    textDecorationLine: 'line-through',
    textDecorationThickness: '1px'
  },
  rateTextPosition: {
    alignSelf: 'flex-end'
  },
  rateTextVerticalPosition: {
    top: -8
  }
});